import { restClient } from '../../client';
import { AppointmentRecurring } from '../../resources';


export type PatientIsAvailableForDateInput = {
  recurring: AppointmentRecurring;
  datetime: string;
  patient_id: string;
};


export type PatientIsAvailableForDateOutput = {
  available: boolean;
  error?: string;
};


export const patientIsAvailableForDate = restClient.createRequest<PatientIsAvailableForDateInput, PatientIsAvailableForDateOutput>({
  url: '/api/v1/appointment/patient/is-available-for-date',
  method: 'POST',
});
